import React, { useEffect, useRef, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Button, Checkbox, Col, Form, Input, InputNumber, Row, Select, Spin } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Title from 'antd/es/typography/Title';
import { checkIntKrQuantiAccumulateDraftYear, checkIntKrQuantiManualDraftYear, getKrQuantiAccumulateCheckInDraftYear, getKrQuantiManualCheckInDraftYear, reset } from 'app/entities/checkIn/checkIn-draft.reducer';
import CommentComponent from 'app/entities/comment/comment';
import ObjectiveUpdate from 'app/entities/objective/form/objective-update';
import { KrTypes } from 'app/shared/model/enum/kr.enum';
import { QuantitativeEvaluationType } from 'app/shared/model/enum/quantitativeEvaluation.enum';
import { StatusType } from 'app/shared/model/enum/status.enum';
import { TrendingTypes } from 'app/shared/model/enum/trending.enum';
import { formatNumber, parseNumber } from 'app/shared/util/help';
import { displayPercent, formatPoint, percent } from 'app/shared/util/percent';
import { filterOption } from 'app/shared/util/select-filter';
import * as _ from 'lodash';
import KRUpdate from '../../kr-update';
import ReportQualitativeResultView from '../view/reportQualitativeResult';
import ReportQuantitativeResultView from '../view/reportQuantitativeResult';

type IReportQuantitativeResult = {
  handleClose: (isReload?: boolean) => void;
  krCheckIn?: any;
  handleNextData: () => void;
  setUpdateSuccess: (isReload?: boolean) => void;
};

export const ReportQuantitativeResult = ({ handleClose, krCheckIn, handleNextData, setUpdateSuccess }: IReportQuantitativeResult) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const filters = useAppSelector(state => state.filters.orgCheckIn);
  const workStatusList = useAppSelector(state => state.common.workStatus);
  const entity = useAppSelector(state => state.checkInDraft.entity);
  const isLoading = useAppSelector(state => state.checkInDraft.loading);
  const isUpdating = useAppSelector(state => state.checkInDraft.updating);
  const [isOpenModalFormKr, setIsOpenModalFormKr] = useState(false);
  const [isOpenModalFormObjective, setIsOpenModalFormObjective] = useState(false);
  const [isOpenDrawerComment, setOpenDrawerComment] = useState(false);
  const [isShowModalQuantitativeView, setShowModalQuantitativeView] = useState(false);
  const [isShowModalQualitativeView, setShowModalQualitativeView] = useState(false);

  // watch values form
  const workStatusValues = Form.useWatch('workStatus', form);
  const resultTenMonthValues = Form.useWatch('resultTenMonth', form);
  const resultNovValues = Form.useWatch('novResult', form);
  const resultDecValues = Form.useWatch('decResult', form);
  const resultYearValues = Form.useWatch('resultYear', form);

  useEffect(() => {
    if (krCheckIn && filters) {
      form.resetFields();
      innitData();
    }
  }, [krCheckIn]);

  useEffect(() => {
    if (entity) {
      form.setFieldsValue({ reportScheduleName: entity.reportScheduleName })
      if (entity?.workResult) {
        form.setFieldValue('workStatus', entity?.workResult?.workStatus)
        form.setFieldValue('solution', entity?.workResult?.solution)
        form.setFieldValue('unFinishNote', entity?.workResult?.unfinishNote)
        form.setFieldValue('note', entity?.workResult?.note)
        form.setFieldValue('issue', entity?.workResult?.issue)
      }
      if (entity?.wholeYear) {
        form.setFieldValue('resultYear', entity?.wholeYear?.result)
        form.setFieldValue('completionRateYear', formatPoint(entity?.wholeYear?.finalPoint))
      }
      if (entity?.firstTenMonth) {
        form.setFieldValue('resultTenMonth', entity?.firstTenMonth?.result)
      }
      if (entity?.novMonth) {
        form.setFieldValue('novResult', entity?.novMonth?.result)
      }
      if (entity?.decMonth) {
        form.setFieldValue('decResult', entity?.decMonth?.result)
      }
    }
  }, [entity]);

  useEffect(() => {
    if (krCheckIn?.krType === KrTypes.AccumulateQuantitative) {
      // ước thực hiện cả năm
      const realizedEstimateYear = (resultTenMonthValues ?? 0) + (resultNovValues ?? 0) + (resultDecValues ?? 0)
      if (_.isInteger(realizedEstimateYear)) form.setFieldValue('resultYear', realizedEstimateYear);
      else form.setFieldValue('resultYear', parseFloat(realizedEstimateYear?.toFixed(2)));
    }

  }, [resultTenMonthValues, resultNovValues, resultDecValues])

  useEffect(() => {
    if (entity?.wholeYear?.evaluationMethodQuantitative === QuantitativeEvaluationType.Point) {
      const completionRateYear = displayPercent(
        calculatorPercentByTrending(
          entity?.krMetaData?.metricType,
          resultYearValues,
          entity?.wholeYear?.metricValue,
        ),
      );
      if (_.isInteger(completionRateYear)) form.setFieldValue('completionRateYear', completionRateYear);
      else form.setFieldValue('completionRateYear', parseFloat(completionRateYear.toFixed(2)));
    }
  }, [resultYearValues])

  const innitData = () => {
    if (krCheckIn?.krType === KrTypes.AccumulateQuantitative)
      dispatch(getKrQuantiAccumulateCheckInDraftYear(krCheckIn?.id));
    else
      dispatch(getKrQuantiManualCheckInDraftYear(krCheckIn?.id));
  };

  const calculatorPercentByTrending = (calculation, numerator, denominator): number => {
    if (calculation === TrendingTypes.Above) {
      if (denominator > 0) return (numerator ?? 0) / denominator;
      return 0;
    } else {
      if (numerator > 0) return denominator / numerator;
      return 0;
    }
  };

  const handleSubmit = values => {
    if (krCheckIn?.krType === KrTypes.AccumulateQuantitative) {
      const payload = {
        ...values,
        krId: krCheckIn?.id,
        unfinishNote: values.unFinishNote,
        finalPoint: percent(values.completionRateYear),
        firstTenMonthResult: values.resultTenMonth,
      };
      dispatch(checkIntKrQuantiAccumulateDraftYear(payload))
        .then(response => {
          if (response && response.payload) {
            const result = (response.payload as any).data
            if (!result) return;
            form.resetFields();
            handleClose(true);
          }
        })
    }
    else {
      const payload = {
        ...values,
        krId: krCheckIn?.id,
        finalPoint: percent(values.completionRateYear),
        unfinishNote: values.unFinishNote,
        wholeYearResult: values.resultYear,
      };
      dispatch(checkIntKrQuantiManualDraftYear(payload)).then(response => {
        if (response && response.payload) {
          const result = (response.payload as any).data
          if (!result) return;
          form.resetFields();
          handleClose(true);
        }
      });
    }
  };

  const handleNextKr = () => {
    form
      .validateFields()
      .then(values => {
        if (krCheckIn?.krType === KrTypes.AccumulateQuantitative) {
          const payload = {
            ...values,
            krId: krCheckIn?.id,
            unfinishNote: values.unFinishNote,
            finalPoint: percent(values.completionRateYear),
            firstTenMonthResult: values.resultTenMonth,
          };
          dispatch(checkIntKrQuantiAccumulateDraftYear(payload))
            .then(response => {
              if (response && response.payload) {
                const result = (response.payload as any).data
                if (!result) return;
                dispatch(reset());
                form.resetFields();
                setUpdateSuccess(true);
                form.scrollToField('reportScheduleName');
                handleNextData();
              }
            })
        }
        else {
          const payload = {
            ...values,
            krId: krCheckIn?.id,
            finalPoint: percent(values.completionRateYear),
            unfinishNote: values.unFinishNote,
            wholeYearResult: values.resultYear,
          };
          dispatch(checkIntKrQuantiManualDraftYear(payload)).then(response => {
            if (response && response.payload) {
              const result = (response.payload as any).data
              if (!result) return;
              dispatch(reset());
              form.resetFields();
              form.scrollToField('reportScheduleName');
              handleNextData();
            }
          });
        }
      })
      .catch((err) => {
        return err;
      })
  };

  const handleSkipKr = () => {
    handleNextData();
  };

  const handleEditKr = () => {
    setIsOpenModalFormKr(true);
  };

  const handleCloseModelKr = () => {
    setIsOpenModalFormKr(false);
  };

  const handleEditObjective = () => {
    setIsOpenModalFormObjective(true);
  };

  const handleCloseModelObjective = () => {
    setIsOpenModalFormObjective(false);
  };

  const handleShowDrawerComment = () => {
    setOpenDrawerComment(true);
  };

  const handleCloseDrawerComment = () => {
    setOpenDrawerComment(false);
  };

  const handleViewReportResult = (event) => {
    event.preventDefault();
    if (krCheckIn?.krType === KrTypes.Qualitative) {
      setShowModalQualitativeView(true);
    } else {
      setShowModalQuantitativeView(true);
    }
  };

  const handleCloseModalQuantitativeView = () => {
    setShowModalQuantitativeView(false);
  };
  const handleCloseModalQualitativeView = () => {
    setShowModalQualitativeView(false);
  };

  return (
    <Spin delay={500} spinning={isUpdating || isLoading}>
      <Form ref={formRef} size="large" form={form} className='fw-bold' onFinish={handleSubmit} layout="vertical">
        <Row>
          <Col md={20}>
            <Title className="fw-bold" level={2}>
              {`Báo cáo thực hiện KR ${filters?.accountableName ? filters.accountableName : ''}`}
            </Title>
          </Col>
          <Col md={1} />
          <Col md={3}><Button onClick={handleShowDrawerComment}>Ý kiến trao đổi</Button></Col>
        </Row>
        <Row>
          <Col md={5}>
            <Form.Item label="Kỳ kế hoạch">
              <Input className="w-100" disabled value={entity?.planPeriodName} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={5}>
            <Form.Item label="Kỳ báo cáo" name={'reportScheduleName'}>
              <Input size='large' readOnly />
            </Form.Item>
          </Col>
          {/* <Col md={1} />
          <Col>
            <div className="mt-4">
              <span className="cursor-pointer text-primary" onClick={() => handleEditKr()}>
                {`Xem chi tiết KR >`}
              </span>
              <br />
              <span className="cursor-pointer text-primary" onClick={() => handleEditObjective()}>
                {`Xem chi tiết mục tiêu >`}
              </span>
            </div>
          </Col> */}
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item label={`Mục tiêu - ${entity?.objective?.code}`}>
              <TextArea rows={1} className="w-100" disabled value={entity?.objective?.purpose} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={3}>
            <Form.Item label="Lĩnh vực">
              <Input className="w-100" disabled value={entity?.objective?.fieldName} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={3}>
            <Form.Item label="Dự án">
              <Input className="w-100" disabled value={entity?.objective?.projectName} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item label="Mảng công việc">
              <Input className="w-100" disabled value={entity?.objective?.workTypeName} size="large" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <Form.Item label="Mã">
              <Input className="w-100" disabled value={entity?.krMetaData?.code} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={12}>
            <Form.Item label="Tên chỉ tiêu">
              <Input className="w-100" disabled value={entity?.krMetaData?.metricName} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={6}>
            <Form.Item label="Đơn vị tính">
              <Input className="w-100" disabled value={entity?.krMetaData?.metricUnit} size="large" />
            </Form.Item>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col className="fw-bold h3" md={11}>
            ƯỚC THỰC HIỆN {entity?.reportScheduleName}
          </Col>
          <Col md={1} />
          <Col md={12}><span onClick={(e) => { handleViewReportResult(e) }} className='text-primary cursor-pointer fw-bold'>Xem kết quả thực hiện KR</span></Col>
        </Row>
        {krCheckIn?.krType === KrTypes.AccumulateQuantitative ? (
          <>
            <Row>
              <Col className='d-flex' md={24}>
                <Col md={4}></Col>
                <Col md={1} />
                <Col md={6}>Kế hoạch</Col>
                <Col md={1} />
                <Col md={6}>Ước thực hiện</Col>
                <Col md={1} />
                <Col md={5}>So sánh</Col>
              </Col>
            </Row>

            <Row className='mt-3'>
              <Col className='d-flex' md={24}>
                <Col md={4}>10 tháng đầu năm</Col>
                <Col md={1} />
                <Col md={6}>
                </Col>
                <Col md={1} />
                <Col md={6}>
                  <Form.Item name={'resultTenMonth'}>
                    <InputNumber
                      formatter={formatNumber}
                      parser={parseNumber}
                      disabled
                      className="w-100"
                      size="large"
                    />
                  </Form.Item>
                </Col>
                <Col md={1} />
                <Col md={5}>
                </Col>
              </Col>
            </Row>

            <Row className='mt-3'>
              <Col className='d-flex' md={24}>
                <Col md={4}>Tháng 11</Col>
                <Col md={1} />
                <Col md={6}>
                  <Form.Item>
                    <InputNumber
                      disabled
                      value={entity?.novMonth?.metricValue}
                      formatter={formatNumber}
                      parser={parseNumber}
                      className="w-100"
                      size="large"
                    />
                  </Form.Item>
                </Col>
                <Col md={1} />
                <Col md={6}>
                  <Form.Item name={'novResult'}>
                    <InputNumber
                      formatter={formatNumber}
                      parser={parseNumber}
                      className="w-100"
                      size="large"
                    />
                  </Form.Item>
                </Col>
                <Col md={1} />
                <Col md={5}>
                  <Form.Item>
                    <InputNumber
                      disabled
                      value={_.round(displayPercent(resultNovValues / entity?.novMonth?.metricValue), 2)}
                      formatter={formatNumber}
                      parser={parseNumber}
                      className="w-100"
                      size="large"
                      addonAfter="%"
                    />
                  </Form.Item>
                </Col>
              </Col>
            </Row>

            <Row className='mt-3'>
              <Col className='d-flex' md={24}>
                <Col md={4}>Tháng 12</Col>
                <Col md={1} />
                <Col md={6}>
                  <Form.Item>
                    <InputNumber
                      disabled
                      value={entity?.decMonth?.metricValue}
                      formatter={formatNumber}
                      parser={parseNumber}
                      className="w-100"
                      size="large"
                    />
                  </Form.Item>
                </Col>
                <Col md={1} />
                <Col md={6}>
                  <Form.Item name={'decResult'}>
                    <InputNumber
                      formatter={formatNumber}
                      parser={parseNumber}
                      className="w-100"
                      size="large"
                    />
                  </Form.Item>
                </Col>
                <Col md={1} />
                <Col md={5}>
                  <Form.Item>
                    <InputNumber
                      disabled
                      value={_.round(displayPercent(resultDecValues / entity?.decMonth?.metricValue), 2)}
                      formatter={formatNumber}
                      parser={parseNumber}
                      className="w-100"
                      size="large"
                      addonAfter="%"
                    />
                  </Form.Item>
                </Col>
              </Col>
            </Row>

            <Row className='mt-3'>
              <Col className='d-flex' md={24}>
                <Col md={4}>Cả năm</Col>
                <Col md={1} />
                <Col md={6}>
                  <Form.Item>
                    <InputNumber
                      disabled
                      value={entity?.wholeYear?.metricValue}
                      formatter={formatNumber}
                      parser={parseNumber}
                      className="w-100"
                      size="large"
                    />
                  </Form.Item>
                </Col>
                <Col md={1} />
                <Col md={6}>
                  <Form.Item name={'resultYear'}>
                    <InputNumber
                      formatter={formatNumber}
                      parser={parseNumber}
                      className="w-100"
                      size="large"
                      disabled={krCheckIn?.krType === KrTypes.AccumulateQuantitative}
                    />
                  </Form.Item>
                </Col>
                <Col md={1} />
                <Col md={5}>
                  <Form.Item>
                    <InputNumber
                      disabled
                      value={_.round(displayPercent(resultYearValues / entity?.wholeYear?.metricValue), 2)}
                      formatter={formatNumber}
                      parser={parseNumber}
                      className="w-100"
                      size="large"
                      addonAfter="%"
                    />
                  </Form.Item>
                </Col>
              </Col>
            </Row>

          </>
        ) :
          (
            <Row>
              <Col md={4}>
                <Form.Item label={`Chỉ tiêu năm`}>
                  <InputNumber
                    disabled
                    value={entity?.wholeYear?.metricValue}
                    formatter={formatNumber}
                    parser={parseNumber}
                    className="w-100"
                    size="large"
                  />
                </Form.Item>
              </Col>
              <Col md={1} />
              <Col md={6}>
                <Form.Item label={`Ước thực hiện cả năm`} name={'resultYear'}>
                  <InputNumber
                    formatter={formatNumber}
                    parser={parseNumber}
                    className="w-100"
                    size="large"
                  />
                </Form.Item>
              </Col>
            </Row>
          )
        }
        <Row>
          <Col md={11}>
            <Form.Item label="Tỷ lệ hoàn thành (%)">
              <TextArea
                rows={1}
                disabled
                className="w-100"
                value={entity?.wholeYear?.evaluationMethodQuantitativeNote}
                size="large"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item label={`Cả năm`} name={'completionRateYear'}>
              <InputNumber
                disabled={entity?.wholeYear?.evaluationMethodQuantitative === QuantitativeEvaluationType.Point}
                formatter={formatNumber}
                parser={parseNumber}
                className="w-100"
                size="large"
                addonAfter="%"
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col md={7}>
            <Form.Item label="Tình trạng KR năm"
              rules={[{ required: true, message: 'Hãy chọn tình trạng' }]}
              name="workStatus">
              <Select
                filterOption={filterOption}
                allowClear
                showSearch
                size="large"
                options={workStatusList}
                placeholder="Chọn tình trạng"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={16}>
            <Form.Item
              label="Lý do (Không hoàn thành/Tạm dừng/Hủy)"
              rules={[
                {
                  required: workStatusValues && (workStatusValues === StatusType.Postponed || workStatusValues === StatusType.Cancel || workStatusValues === StatusType.NotCompleted),
                  message: `Hãy nhập lý do`,
                },
              ]}
              name={'unFinishNote'}
            >
              <TextArea rows={1} placeholder="Nhập lý do" size="large" />
            </Form.Item>

          </Col>
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item label="Khó khăn & nguyên nhân" name={'issue'}>
              <TextArea rows={6} placeholder="Nhập khó khăn & nguyên nhân" size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={12}>
            <Form.Item label="Giải pháp và kiến nghị" name={'solution'}>
              <TextArea rows={6} placeholder="Nhập giải pháp và kiến nghị" size="large" />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col md={24}>
            <Form.Item label="Link tài liệu đính kèm" name={'note'}>
              <TextArea placeholder="Nhập tài liệu đính kèm về kết quả thực hiện" size="large" />
            </Form.Item>
            <Form.Item valuePropName="checked" name={'sendingNotification'}>
              <Checkbox>Gửi thông báo đến người nhận</Checkbox>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Row className="d-flex gap-3 mt-3" justify="end">
            <Col>
              <Button
                className="green"
                onClick={() => {
                  handleNextKr();
                }}
                disabled={isUpdating}
              >
                Lưu & Chuyển sang check in KR khác
              </Button>
            </Col>
            <Col>
              <Button className="primary" htmlType="submit" disabled={isUpdating}>
                Lưu
              </Button>
            </Col>
            <Col>
              <Button
                className="secondary"
                onClick={() => {
                  handleSkipKr();
                }}
              >
                Bỏ qua
              </Button>
            </Col>
            <Col>
              <Button
                className="secondary"
                onClick={() => {
                  handleClose();
                }}
              >
                Hủy
              </Button>
            </Col>
          </Row>
        </Form.Item>
        {isOpenDrawerComment &&
          <CommentComponent topicId={krCheckIn?.id} handleDrawerComment={handleCloseDrawerComment} isOpenDrawerComment={isOpenDrawerComment} />
        }
        {isOpenModalFormObjective && (
          <ObjectiveUpdate isOpen={isOpenModalFormObjective} id={entity?.objective?.id} onClose={handleCloseModelObjective} />
        )}
        {isOpenModalFormKr && (
          <KRUpdate
            isOpen={isOpenModalFormKr}
            idKrBaseSelected={krCheckIn?.id}
            idObjective={entity?.objective?.id}
            planPeriodType={filters?.planPeriodType}
            krTypeRequest={krCheckIn?.krType}
            planPeriodIdSelected={filters?.planPeriodId}
            onClose={handleCloseModelKr}
          />
        )}
        {isShowModalQuantitativeView && (
          <ReportQuantitativeResultView
            isOpen={isShowModalQuantitativeView}
            idKrSelected={krCheckIn?.id}
            onClose={handleCloseModalQuantitativeView}
          />
        )}
        {isShowModalQualitativeView && (
          <ReportQualitativeResultView
            isOpen={isShowModalQualitativeView}
            idKrSelected={krCheckIn?.id}
            onClose={handleCloseModalQualitativeView}
          />
        )}
      </Form>
    </Spin>
  );
};

export default ReportQuantitativeResult;
